import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  AccountCircleOutlined,
  DonutLargeOutlined,
  EmailOutlined,
  HttpOutlined,
  LocalPhoneOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetDriverDetailQuery } from "store/services/driverApi";

import { useAuth } from "hooks/useAuth";

const DriverInfoScreen = () => {
  const { viewEntity } = useAuth();

  const driverId = viewEntity?.entity?.driver?._id;

  const breadcrumbs = [
    {
      title: "Driver Info",
    },
  ];

  // RTK Query
  const {
    data: driverDetail,
    isLoading: loadingDriverDetail,
    error,
  } = useGetDriverDetailQuery(driverId);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingDriverDetail}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingDriverDetail ? (
          <Box padding={3}>
            <Typography variant="h6">{driverDetail?.name}</Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccountCircleOutlined color="primary" />}
                  title="Display Name"
                  subtitle={driverDetail?.name}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <HttpOutlined color="primary" />}
                  title="Domain"
                  subtitle={driverDetail?.driverId}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <EmailOutlined color="primary" />}
                  title="Assistance Email"
                  subtitle={driverDetail?.email}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalPhoneOutlined color="primary" />}
                  title="Assistance Phone"
                  subtitle={driverDetail?.licenceId}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalPhoneOutlined color="primary" />}
                  title="Assistance Phone"
                  subtitle={driverDetail?.assigned_vehicle_ids}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalPhoneOutlined color="primary" />}
                  title="Assistance Phone"
                  subtitle={driverDetail?.medicalCertificationStatus}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DonutLargeOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={driverDetail?.status === "Active"} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DriverInfoScreen;
